import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { OptionsService } from '../services/options.service'
import { IOptionsResponse } from '../../../common/common.types'
import { setNppFormOptions } from '../store/options.actions'

export function* getNppFormOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getNppFormOptions])
    const { entity } = response
    yield put(setNppFormOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getNppFormOptions() error: ${e}`))
  }
}

export function* getNppFormOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getNppFormOptions)
}
